import React from 'react';
import { LoadingWrapper } from './Loading.styled';
import axios from 'axios';
import { populateOutputs } from '../../features/outputs/outputs';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/primaryLogo2.png';
import { Logo } from './Loading.styled';
import { populateInputs, resetEnableRecalculate } from '../../features/inputs/inputs';
import { assignSearchTerms } from '../../features/incentiveSearch/search';

function Loading () {
   const sessionId = useSelector((state) => state.sessionId.value);
   const token = useSelector((state) => state.token.value);
   const navTo = useSelector((state) => state.analysisPageNav.value);
   const dispatch = useDispatch();
   const navigate = useNavigate();

   useEffect(() => {
      axios.get(`${process.env.REACT_APP_API_URL}api/resultpull`,
         { headers: 
            { 
            'Authorization': `${token}`, 
            'Content-Type': 'application/json',
            'sessionId': `${sessionId}`
            }
         }
      )
      .then(response => {
         if (typeof response.data === 'string') {
            response.data = response.data.replace('NaN', "0");
            response.data = JSON.parse(response.data);
         }
         dispatch(populateOutputs(response.data));
         dispatch(populateInputs({
            ...response.data.userInputs, 
            optIn: response.data.userInputs.emailAddress !== null,
            newDevelopment: Boolean(response.data.userInputs.newDevelopment), 
            incentives: response.data.incentives.map(i => ({...i, frontendID: i.index})),
            costMonthlyArr: response.data.cost.costMonthlyArr,
            costOneTimeArr: response.data.cost.costOneTimeArr,
            roiMonthlyArr: response.data.roi.roiMonthlyArr,
            roiAnnualArr: response.data.roi.roiAnnualArr,
            customRole: response.data.userInputs.role.includes("Other") ?  response.data.userInputs.role.filter(r => !['Developer', 'Owner', 'Property Manager', 'Other'].includes(r))[0] : null,
         }));
         dispatch(resetEnableRecalculate(false));
         dispatch(assignSearchTerms({searchTerms: [], state: response.data.userInputs.state, utility: null, stateCode: null}));
         navigate(`/analysis/${navTo}`);
      })
      .catch(error => {
         console.error(error);
         navigate(`/input`, {state: { popup: true }});
      });
      
   });

   return (
   <LoadingWrapper>
      <Logo src={logo} alt="MFH Logo" />
      <h1>Loading...</h1>
   </LoadingWrapper>
   )};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
